import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import useModalContext from '../utils/useModalContext';

var ModalContents = function ModalContents(props) {
  var _useModalContext = useModalContext(),
      id = _useModalContext.id;

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    id: "dialog-contents-".concat(id)
  }));
};

export default ModalContents;